module.exports = __webpack_public_path__ + "img/bg_ghost_15@3x.95bbca73.png";